const originalAddEventListener = window.addEventListener.bind(window)
window.addEventListener = function (type, listener, options) {
	if (type === 'unload') {
		return originalAddEventListener('pagehide', listener, options)
	}
	return originalAddEventListener(type, listener, options)
}